export const IPAD_PORTRAIT_WIDTH = 768;
export const MENU_RESIZE_THROTTLE = 100;

let MOBILE_SUBNAV_ACTIVATED = false;

export function isMWebView(win) {
  return win.innerWidth <= IPAD_PORTRAIT_WIDTH;
}

export function activateMobileSubnav(doc) {
  if (MOBILE_SUBNAV_ACTIVATED) {
    return;
  }
  const subnav = doc.querySelector('.cw_navbar__subnav');
  if (subnav) {
    const mobileNav = doc.querySelector('.cw_navbar_mobile');
    mobileNav.parentElement.insertBefore(subnav, mobileNav.nextSibling);
  }
  MOBILE_SUBNAV_ACTIVATED = true;
}

export function deactivateMobileSubnav(doc) {
  if (!MOBILE_SUBNAV_ACTIVATED) {
    return;
  }
  const subnav = doc.querySelector('.cw_navbar__subnav');
  if (subnav) {
    doc.querySelector('.cw_navbar').appendChild(subnav);
  }
  MOBILE_SUBNAV_ACTIVATED = false;
}

const toggleHeaderNavImpressions = ({ win, isOpen, menuContents }) => {
  if (!isMWebView(win) || isOpen) {
    menuContents.removeAttribute('data-cwt-im-off');
  } else {
    menuContents.setAttribute('data-cwt-im-off', 'true');
  }
  window.dispatchEvent(new CustomEvent('CWTMenu'));
};

// show/hide the menu
const toggleMenu = ({ win, isOpen, menuContents, menuButton, menuCheckBox }) => {
  menuCheckBox.checked = isOpen;
  if (isOpen) {
    menuContents.classList.remove('cw_drawer_closed');
    menuButton.classList.add('cw_navbar_mobile--open');
  } else {
    menuButton.classList.remove('cw_navbar_mobile--open');
  }
  toggleHeaderNavImpressions({ win, isOpen, menuContents });
};

const focusLogoutMobileLink = ({ checked, logoutMobileLink }) => {
  if (checked && logoutMobileLink) {
    logoutMobileLink.focus();
  }
};

const menuContentsAddClass = ({ menuCheckBox, menuContents }) => {
  if (!menuCheckBox.checked) {
    menuContents.classList.add('cw_drawer_closed');
  }
};

const confirmAvailabilityOfElements = ({ menuButton, menuCheckBox, menuContents }) =>
  !menuButton || !menuCheckBox || !menuContents;

const getToggleTriggerAnimatedClass = (checked) => {
  if (checked) {
    return '.vx_globalNav-toggleTrigger_animated_open';
  }
  return '.vx_globalNav-toggleTrigger_animated_close';
};

const getMenuContents = (doc) => doc.querySelector('.cw_navbar_drawer');

function initHeaderInteractions(win, doc) {
  MOBILE_SUBNAV_ACTIVATED = false;
  const menuCheckBox = doc.getElementById('toggleNavigation');
  const logoutMobileLink = doc.getElementById('header-logout_mobile');
  const menuButton = doc.getElementById('toggleNavigationButton');
  const menuContents = getMenuContents(doc);
  let resizeThrottleTimeoutId;
  let autoCloseOnLoad = true;

  // since this script is deployed separately, we need to confirm the availability of these elements
  if (confirmAvailabilityOfElements({ menuButton, menuCheckBox, menuContents })) {
    return;
  }

  // hide input
  menuCheckBox.style.display = 'none';

  // once the drawer if fully closed, hide content so that screenreaders will not try to read it for mweb
  doc.querySelector('.vx_foreground-container')?.addEventListener('transitionend', () => {
    menuContentsAddClass({ menuCheckBox, menuContents });
  });

  // by default, menu is closed
  toggleMenu({ win, isOpen: false, menuContents, menuButton, menuCheckBox });
  menuContents.classList.add('cw_drawer_closed');

  // click handler for menu button
  menuButton.addEventListener('click', () => {
    autoCloseOnLoad = false; // cancel auto close
    const checked = !menuCheckBox.checked;
    toggleMenu({ win, isOpen: checked, menuContents, menuButton, menuCheckBox });
    focusLogoutMobileLink({ checked, logoutMobileLink });
    // for analytics
    menuButton.querySelector(getToggleTriggerAnimatedClass(checked))?.click();
  });

  window.addEventListener('load', () => {
    // NOTE: workaround for issue on desktop chrome,
    // where checkbox is not checked until onload has fired
    // when back button is used
    if (autoCloseOnLoad && menuCheckBox.checked) {
      toggleMenu({ win, isOpen: false, menuContents, menuButton, menuCheckBox });
    }
  });

  menuButton.querySelector('.vx_globalNav-toggleTrigger_animated_open')?.addEventListener('click', (evt) => {
    evt.stopPropagation();
  });

  menuButton.querySelector('.vx_globalNav-toggleTrigger_animated_close')?.addEventListener('click', (evt) => {
    evt.stopPropagation();
  });
  // resize handler
  win.addEventListener('resize', () => {
    clearTimeout(resizeThrottleTimeoutId);
    resizeThrottleTimeoutId = setTimeout(() => {
      // close menu if its not supposed to have it
      if (win.innerWidth > IPAD_PORTRAIT_WIDTH) {
        toggleMenu({ win, isOpen: false, menuContents, menuButton, menuCheckBox });
        deactivateMobileSubnav(doc);
      } else {
        activateMobileSubnav(doc);
      }
    }, MENU_RESIZE_THROTTLE);
  });

  if (isMWebView(win)) {
    activateMobileSubnav(doc);
  }
}

export default function initHeader(win, doc) {
  /**
   *  Run mobile init after the dom has loaded
   */
  doc.addEventListener('DOMContentLoaded', () => initHeaderInteractions(win, doc));
  doc.getElementById('close-deprecated-message')?.addEventListener('click', function () {
    this.parentElement.style.display = 'none';
  });
}
